import gitHub from '../../img/gitHub.png'
import linkedin from '../../img/linkedin.png'
import instagram from '../../img/instagram.png'
import logo from '../../img/logoBlue.png'
import email from '../../img/email.png'

import styles from './footer.module.css'

export default function Footer() {
  return (
    <div className={styles.footer}>
      <div className={styles.footerInfo}>
        <div className={styles.footerInfoLogo}>
          <a href="/">
            <img src={logo} alt="Logo Riccetto Dev" />
          </a>
        </div>
        <div className={styles.footerInfoLink}>
          <div className={styles.containerLink}>
            <a href="https://github.com/RiccettoDev" target="_blank">
              <div className={styles.link}>
                <img src={gitHub} alt="link GitHub" />
              </div>
            </a>
            <a href="https://www.instagram.com/duriccetto/" target="_blank">
              <div className={styles.link}>
                <img src={instagram} alt="link Instagram" />
              </div>
            </a>
            <a
              href="https://www.linkedin.com/in/eduardo-peixoto-riccetto-094a53a2/"
              target="_blank"
            >
              <div className={styles.link}>
                <img src={linkedin} alt="link Linkedin" />
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.footerLine}></div>
      <div className={styles.footerContact}>
        <div className={styles.link}>
          <img src={email} alt="link E-mail" />
        </div>
        <h2>riccettodev@gmail.com</h2>
      </div>
    </div>
  )
}
